import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  status: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(3),
  },
  errorSubContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  offerUpdatedAt: {
    fontSize: '11px',
    fontWeight: 500,
    color: theme.palette.labraText.description,
    lineHeight: '16px',
  },
  noStatusBar: {
    display: 'none',
  },
}))
